export default "__VITE_ASSET__323ece47__"